__turbopack_context__.v({
  "helios-photo-mosaic": "D_GRHq_helios-photo-mosaic",
  "helios-photo-mosaic--backdrop": "D_GRHq_helios-photo-mosaic--backdrop",
  "helios-photo-mosaic--frame": "D_GRHq_helios-photo-mosaic--frame",
  "helios-photo-mosaic--tone-inverse": "D_GRHq_helios-photo-mosaic--tone-inverse",
  "helios-photo-mosaic-scroll": "D_GRHq_helios-photo-mosaic-scroll",
  "helios-photo-mosaic__caption": "D_GRHq_helios-photo-mosaic__caption",
  "helios-photo-mosaic__column": "D_GRHq_helios-photo-mosaic__column",
  "helios-photo-mosaic__content": "D_GRHq_helios-photo-mosaic__content",
  "helios-photo-mosaic__description": "D_GRHq_helios-photo-mosaic__description",
  "helios-photo-mosaic__figure": "D_GRHq_helios-photo-mosaic__figure",
  "helios-photo-mosaic__image": "D_GRHq_helios-photo-mosaic__image",
  "helios-photo-mosaic__list": "D_GRHq_helios-photo-mosaic__list",
  "helios-photo-mosaic__list--copy": "D_GRHq_helios-photo-mosaic__list--copy",
  "helios-photo-mosaic__name": "D_GRHq_helios-photo-mosaic__name",
  "helios-photo-mosaic__tile": "D_GRHq_helios-photo-mosaic__tile",
  "helios-photo-mosaic__track": "D_GRHq_helios-photo-mosaic__track",
  "helios-photo-mosaic__viewport": "D_GRHq_helios-photo-mosaic__viewport",
});
